export enum FitnessDataType {
    GPS = "GPS",
    HeartRate = "HEART_RATE",
}
